import { createSlice } from '@reduxjs/toolkit'

const BrowseClassesStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    classes: [],
    status: BrowseClassesStatus.LOADING,
    errorMessage: null,
    paging: {
        pageNo: 1,
        pageSize: 10,
        pageCount: 1,
        totalRecordCount: 1,
    },
}

const browseClassesSlice = createSlice({
    name: 'browseClasses',
    initialState,
    reducers: {
        getClassesRequest: state => {
            state.status = BrowseClassesStatus.LOADING
        },
        getClassesRequestSuccess: (state, action) => {
            state.status = BrowseClassesStatus.SUCCESS
            const { classes, paging } = action.payload
            state.classes = classes.map(classObj => {
                classObj.date = classObj.startdate
                return classObj
            })
            state.paging = paging
        },
        getClassesRequestError: (state, action) => {
            state.status = BrowseClassesStatus.FAILURE
            state.errorMessage = action.payload
        },
    },
})

const {
    getClassesRequest,
    getClassesRequestSuccess,
    getClassesRequestError,
} = browseClassesSlice.actions

export const browseClassesActions = {
    getClassesRequest,
    getClassesRequestSuccess,
    getClassesRequestError,
}

export const browseClassesSelectors = {
    isFetching: state =>
        state.browseClasses.status === BrowseClassesStatus.LOADING,
    errorMessage: state => state.browseClasses.errorMessage,
    hasError: state =>
        state.browseClasses.status === BrowseClassesStatus.FAILURE,
    classes: state => state.browseClasses.classes,
    paging: state => state.browseClasses.paging,
}

const browseClassesReducer = browseClassesSlice.reducer

//For intellisense
export default browseClassesReducer
